module.exports = "<div class=\"tabs\">\n  <div class=\"tab is-tab-selected\">Tab 1</div>\n  <div class=\"tab\">Tab 2</div>\n  <div class=\"tab\">Tab 3</div>\n  <div class=\"tab\">Tab 4</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/raw-loader!/Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/flexbox-patterns/src/examples/tabs.html
// module id = 788
// module chunks = 0